<template>
  <div>
    <KTCodePreview v-if="!hideWrapper" v-bind:title="title">
      <template v-slot:preview>
        <b-form ref="form" lazy-validation class="row">
          <b-container class="bv-example-row">
            <b-row>
              <b-col>
                <div class="form-group">
                  <span>
                    <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
                    đúng format, hoặc có thể tải ở
                    <a :href="urlExcel">đây</a>
                  </span>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span> <b>Bước 2:</b> Tiến hành Import </span>
                <div
                  style="padding-top: 15px"
                  class="d-flex align-items-center"
                >
                  <b-form-file
                    placeholder="Hãy chọn một tập tin"
                    @change="handleFileSelect"
                    :value="file"
                    ref="file-input"
                    class="mb-2 flex-grow-1"
                    :disabled="uploading"
                  ></b-form-file>
                  <b-button
                    v-if="file"
                    variant="outline-danger"
                    size="sm"
                    class="ml-2 mb-2"
                    :disabled="uploading"
                    @click="handleClearFile"
                    title="Xóa file đã chọn"
                  >
                    <i class="la la-times"></i>
                  </b-button>
                </div>
                <div v-if="uploading" class="mt-2">
                  <b-spinner small variant="primary" class="mr-2"></b-spinner>
                  <span>Đang đọc file...</span>
                </div>
                <b-progress :value="progress" :max="100" show-progress>
                  <b-progress-bar
                    :value="progress"
                    :label="`${progress.toFixed(2)}%`"
                  ></b-progress-bar>
                </b-progress>
              </b-col>
            </b-row>
          </b-container>
          <!-- Slot để parent component chèn table vào đây -->
          <slot name="table"></slot>
        </b-form>
      </template>
      <template v-slot:foot v-if="!hideFooter">
        <div class="bv-example-row container">
          <b-row>
            <SaveButton
              :is-busy="uploading"
              :disabled="disabled"
              @click="handleSubmit"
            />
            <router-link :to="cancelRoute" tag="button">
              <b-button
                style="margin-left: 10px; font-weight: 600; width: 70px"
                variant="secondary"
                size="sm"
                >Hủy</b-button
              >
            </router-link>
          </b-row>
        </div>
      </template>
    </KTCodePreview>

    <b-form v-else ref="form" lazy-validation class="row">
      <b-container class="bv-example-row">
        <b-row>
          <b-col>
            <div class="form-group">
              <span>
                <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel đúng
                format, hoặc có thể tải ở
                <a :href="urlExcel">đây</a>
              </span>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span> <b>Bước 2:</b> Tiến hành Import </span>
            <div style="padding-top: 15px" class="d-flex align-items-center">
              <b-form-file
                placeholder="Hãy chọn một tập tin"
                @change="handleFileSelect"
                :value="file"
                ref="file-input"
                class="mb-2 flex-grow-1"
                :disabled="uploading"
              ></b-form-file>
              <b-button
                v-if="file"
                variant="outline-danger"
                size="sm"
                class="ml-2 mb-2"
                :disabled="uploading"
                @click="handleClearFile"
                title="Xóa file đã chọn"
              >
                <i class="la la-times"></i>
              </b-button>
            </div>
            <div v-if="uploading" class="mt-2">
              <b-spinner small variant="primary" class="mr-2"></b-spinner>
              <span>Đang đọc file...</span>
            </div>
            <b-progress :value="progress" :max="100" show-progress>
              <b-progress-bar
                :value="progress"
                :label="`${progress.toFixed(2)}%`"
              ></b-progress-bar>
            </b-progress>
          </b-col>
        </b-row>
      </b-container>
      <!-- End input session -->

      <!-- Slot để parent component chèn table vào đây -->
      <slot name="table"></slot>
    </b-form>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import SaveButton from '@/view/components/common/SaveButton.vue';

export default {
  name: 'ExcelImport',
  components: {
    KTCodePreview,
    SaveButton,
  },
  props: {
    // Title của page
    title: {
      type: String,
      default: 'Nhập dữ liệu',
    },
    // URL để download file mẫu
    urlExcel: {
      type: String,
      required: true,
    },
    // Route để cancel (redirect về)
    cancelRoute: {
      type: String,
      default: '/',
    },
    // Disabled state cho submit button
    disabled: {
      type: Boolean,
      default: false,
    },
    // File object
    file: {
      type: [Object, File],
      default: null,
    },
    // Uploading state
    uploading: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Number,
      default: 0,
    },
    // Hide footer (useful when used in modal)
    hideFooter: {
      type: Boolean,
      default: false,
    },
    // Hide wrapper (KTCodePreview) - useful when used in modal
    hideWrapper: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleFileSelect(event) {
      this.$emit('file-select', event);
    },
    handleSubmit() {
      this.$emit('submit');
    },
    clearFileInput() {
      if (this.$refs['file-input']) {
        this.$refs['file-input'].reset();
      }
    },
    handleClearFile() {
      this.clearFileInput();
      // Emit event để parent component clear file state
      this.$emit('clear-file');
    },
  },
  watch: {
    // Clear file input khi file prop thay đổi thành null
    file(newVal) {
      if (!newVal && this.$refs['file-input']) {
        this.clearFileInput();
      }
    },
  },
};
</script>

<style scoped></style>
